/**
 * Константи для конфігурації додатку
 */

// Пагінація

export const DEFAULT_PAGE_SIZE = 15;

export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100, 250, 500, 1000] as const;

export const MAX_PAGE_SIZE = 1000;

export const METADATA_PAGE_SIZE = 10;

export const OFFSET_PAGINATION_THRESHOLD = 11000;

// Skeleton loader
export const SKELETON_ROWS_COUNT = 15;

// API endpoints
export const STEAM_STORE_URL = "https://store.steampowered.com/app/";
